import { __extends, __assign } from 'tslib';
import React__default from 'react';
import { Icon } from '../Icon/Icon.component.js';
import { propTypes, defaultProps } from './ImageSelectionButton.types.js';
import styles from './ImageSelectionButton.module.scss.js';

var ImageSelectionButton = /** @class */ (function (_super) {
    __extends(ImageSelectionButton, _super);
    function ImageSelectionButton() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.renderImageStack = function () {
            var images = _this.props.images;
            var firstFiveImages = images.slice(0, 5);
            return (React__default.createElement("div", { className: styles.ImageSelectionButton_imageContainer }, firstFiveImages.map(function (url, i) { return (React__default.createElement("img", { className: styles.ImageSelectionButton_image, alt: 'Preview', src: url, key: i, style: { left: i * 8 + 'px' } })); })));
        };
        return _this;
    }
    ImageSelectionButton.prototype.render = function () {
        var _a = this.props, onClick = _a.onClick, disabled = _a.disabled, className = _a.className, noImagesText = _a.noImagesText;
        return (React__default.createElement("button", { className: styles.ImageSelectionButton + " " + (className || ''), onClick: onClick, disabled: disabled }, this.props.images.length > 0 ? (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(Icon, { name: "AddIcon", alt: "Add image", size: 18, className: styles.ImageSelectionButton_icon }),
            this.renderImageStack())) : (React__default.createElement("div", { className: styles.ImageSelectionButton_textContainer }, noImagesText))));
    };
    ImageSelectionButton.displayName = 'ImageSelectionButton';
    ImageSelectionButton.propTypes = propTypes;
    ImageSelectionButton.defaultProps = __assign({}, defaultProps);
    return ImageSelectionButton;
}(React__default.Component));

export { ImageSelectionButton as default };
